import API from '../api'
import deleteUrl from './paths'

const deleteCommodityApi = (commodityId) =>
	new Promise((resolve, reject) => {
		API.delete(deleteUrl.deleteCommodity, { commodityId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
export { deleteCommodityApi }
